import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    key: _ctx.notificationMessageValue.uuid,
    style: {"margin-top":"4px"},
    location: "top",
    "max-width": "300px",
    color: _ctx.notificationMessageValue.color,
    icon: _ctx.notificationMessageValue.icon,
    variant: "elevated",
    closable: "",
    text: _ctx.notificationMessage.message,
    prominent: "",
    "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateMessages(_ctx.notificationMessageValue.uuid)))
  }, null, 8, ["color", "icon", "text"]))
}